export default [
    { key: 'pattern', title: 'Pattern' },
    { key: 'comfort', title: 'Comfort', type: 'numeric' },
    { key: 'wrinkles', title: 'Wrinkles', type: 'numeric' },
    { key: 'ironing', title: 'Ironing', type: 'numeric' },
    { key: 'fabricCompositionLabel', title: 'Fabric Composition Label' },
    { key: 'fiber_1', title: 'Fiber 1' },
    { key: 'fiber_1_percentage', title: 'Fiber 1 %', type: 'numeric' },
    { key: 'fiber_2', title: 'Fiber 2' },
    { key: 'fiber_2_percentage', title: 'Fiber 2 %', type: 'numeric' },
    { key: 'fiber_3', title: 'Fiber 3' },
    { key: 'fiber_3_percentage', title: 'Fiber 3 %', type: 'numeric' },
    { key: 'default_weave', title: 'Weave' },
    { key: 'default_width', title: 'Width', type: 'numeric' },
    { key: 'default_unit', title: 'Unit' },
    { key: 'default_unit_price', title: 'Unit Price', type: 'numeric' },
    { key: 'default_vat_per_unit', title: 'VAT Per Unit', type: 'numeric' },
    { key: 'default_unit_price_total', title: 'Unit Price Total', type: 'numeric' },
    { key: 'default_currency', title: 'Currency' },
    { key: 'default_yarn_count', title: 'Yarn Count' },
    { key: 'default_density', title: 'Density' },
    { key: 'default_weight', title: 'Weight', type: 'numeric' },
    { key: 'default_coloring_style', title: 'Coloring Style' },
    { key: 'default_finish', title: 'Finish' },
    { key: 'fabricSupplier', title: 'Fabric Supplier' },
    { key: 'current_fabric_supplier_code', title: "Supplier's Fabric ID" },
    { key: 'buttonColor', title: 'Button Color' },
    { key: 'threadColor', title: 'Thread Color' },
    { key: 'embroideryThreadColor', title: 'Embroidery Thread Color' },
    { key: 'sample_book', title: 'Sample Book' },
    { key: 'position_book', title: 'Position Book', type: 'numeric' },
    { key: 'matching', title: 'Matching', type: 'numeric' },
    { key: 'interlining_color', title: 'Interlining Color' },
    { key: 'design_extra', title: 'Design Extra' },
    { key: 'type', title: 'Type' },
    { key: 'note', title: 'Status Note' },
    { key: 'future', title: 'Future' },
    { key: 'usage_type', title: 'Usage Type' },
    { key: 'families', title: 'Fabric Family' },
    { key: 'fabric_class', title: 'Fabric Class' },
    { key: 'gender_suitable_for', title: 'Gender Suitable For' },
    { key: 'is_shirt_fabric', title: 'Is Shirt Fabric' },
    { key: 'is_jersey_fabric', title: 'Is Jersey Fabric' },
    { key: 'is_stretch_fabric', title: 'Is Stretch Fabric' },
    { key: 'interlining', title: 'Interlining' }
]
